module.exports = __webpack_public_path__ + "img/home.3ad8845c.svg";